module.exports = __webpack_public_path__ + "assets/img/example6.3795daa9.jpg";